import { Component, OnInit, OnDestroy, ViewChild, ElementRef, NgZone, Renderer2 } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { MapsAPILoader } from '@agm/core';
import { Router, ActivatedRoute, RoutesRecognized } from '@angular/router';
import { HttpService } from '../../service/http.service';
import { UserPlanService } from '../../service/userplan.service';
import { AppState } from '../../models/app.state';
import { Store } from '@ngrx/store';
import { PostFilterService } from '../../service/post-filter.service';
import { environment } from '../../../environments/environment';
import { eventEmitterService } from '../../service/eventEmitter.service';
import { UserService } from "../../service/user.service";
import * as _ from 'lodash';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { ADD_BUILDING, JOIN_BUILDING } from 'src/app/reducers/building.reducers';

@Component({
  selector: 'app-address-search-bar',
  templateUrl: './address-search-bar.component.html',
  styleUrls: ['./address-search-bar.component.css']
})
export class AddressSearchBarComponent implements OnInit, OnDestroy {

  address: any = {};
  inputAddress;
  reportCoop: FormGroup;
  modalWindow;
  unregisteredAddress;
  submited: boolean;
  modalDismiss: string;
  coords: Object = {};
  imageUrl;
  error;
  addressInput;
  place: google.maps.places.PlaceResult;
  isLoadingActive = false;
  isSuccess = false;
  successMessage: string;
  alert;
  ModalTrigger = false;
  modalToOpen;
  modalTarget;
  errorState: boolean = false;
  isReportToMycoop: boolean = false;
  userPlan;
  href: string = "";
  isAddressBarPageOrPopup = 'addressBarPage';

  emailInvalid = false;
  commentInvalid = false;
  submitted: boolean = false;

  @ViewChild('search',  { static: false })
  public searchElementRef: ElementRef;

  @ViewChild('submitbuild', { static: false })
  public submit: ElementRef;

  @ViewChild('loginButton', { static: false })
  public log: ElementRef;

  test;
  isManagerStatus;
  replaceBuildingByRes = false;

  tags: string[] = ['AngularJS', 'Angluar2']

  constructor(
    private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone,
    private router: Router,
    private _http: HttpClient,
    private _fb: FormBuilder,
    private httpService: HttpService,
    private plan: UserPlanService,
    private userService: UserService,
    private store: Store<AppState>,
    private emitter: eventEmitterService,
    private renderer: Renderer2,
    private route: ActivatedRoute,
    private param: PostFilterService
  ) { }

  ngOnInit() {
    this.href = this.router.url;

    this.mapsAPILoader.load().then(() => {
      const autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement, {
        types: []
      });
      autocomplete.addListener('place_changed', () => {
        this.ngZone.run(() => {
          this.userPlan = this.plan.getUserPlan();
          this.error = null;
          this.place = null;

          this.place = autocomplete.getPlace();
          console.log(this.place, this.userPlan, "===============");
          this.addressInput = this.place.formatted_address;
          this.plan.setError(null);
          this.plan.setBuildingManagerExists(null);

          if (this.userPlan == null) {
            var changeBuildingByRes = this.plan.getchangeBuildingByRes();
            if (changeBuildingByRes != null && changeBuildingByRes.status == 'changeBuildingByRes') {
              if (changeBuildingByRes.currentBuildingPlaceId == this.place.place_id) {
                this.replaceBuildingByRes = true;
              } else {
                this.replaceBuildingByRes = false;
              }
            }
          }
          if (this.place.place_id) {
            setTimeout(() => {
              this.onSubmit();
            }, 10);
          }

          if (this.place.photos) {
            this.imageUrl = this.place.photos[0].getUrl({ 'maxWidth': 128, 'maxHeight': 128 });
            console.log(this.imageUrl);
          } else {
            this.imageUrl = '';
          }
          this.coords = {
            lat: this.place.geometry.location.lat(),
            lng: this.place.geometry.location.lng()
          };
        });
      });
    }).catch((error) => {
      this.openModal('myModal');
    });

    this.emitter.eventEmit$.subscribe(event => {
      if (event.conflict_Adr) {
        this.isAddressBarPageOrPopup = 'addressBarPopup';
      }
      if (event.homeReset) {
        // Handle home reset logic if needed
      }
    });
  }

  ngOnDestroy() {
    this.closeModal('addSearchModal');
  }

  onSubmit() {
    this.address.adr_address = this.place['adr_address'];
    this.address.formattedAddress = this.place.formatted_address;
    this.address.coords = {
      lat: this.place.geometry.location.lat(),
      lng: this.place.geometry.location.lng()
    };
    this.address.placeId = this.place.place_id;

    this.coordsRoundUp(this.address);

    if (this.addressInput == '') {
      this.modalWindow = null;
      this.error = 'Please enter your building address';
      this.isReportToMycoop = false;
      this.unregisteredAddress = this.addressInput;
    } else if (this.place.formatted_address !== this.addressInput) {
      this.error = null;
      this.isReportToMycoop = true;
      this.modalWindow = "#myModal";
    } else {
      if (this.replaceBuildingByRes == true) {
        this.error = "This is your current building, Please search with some other building address";
        this.plan.setError(this.error);
      } else {
        this.plan.setError(null);
      }

      this._http.get<any>(`https://maps.googleapis.com/maps/api/geocode/json?place_id=${this.address.placeId}&key=${environment.googleMapsApiKey}`)
        .pipe(map(res => res))
        .subscribe(data => {
          if (data.status === "OK") {
            let tempCoords = data.results[0].geometry.location;
            let value1 = tempCoords.lat;
            let value2 = tempCoords.lng;
            let length1 = value1.toString().split('.')[1];
            let length2 = value2.toString().split('.')[1];

            length1 = length1 ? length1.length : 0;
            length2 = length2 ? length2.length : 0;

            if (length1 > 7) {
              tempCoords.lat = parseFloat(tempCoords.lat.toFixed(7))
            }

            if (length2 > 7) {
              tempCoords.lng = parseFloat(tempCoords.lng.toFixed(7))
            }

            this.address.coords = tempCoords;

            this.httpService.isManager(tempCoords).subscribe(
              (res) => {
                this.plan.setBuildingManagerExists(null);
                this.plan.setError(null);
                this.isManagerStatus = false;
              },
              (error) => {
                this.plan.setBuildingManagerExists(this.place);
                this.isManagerStatus = true;
                if (this.userPlan == 'manager') {
                  this.error = 'This building already has a manager assigned. Please contact mycoop for further information.';
                  this.isReportToMycoop = false;
                  this.plan.setError(this.error);
                } else {
                  this.plan.setError(null);
                }
              });

            this.modalWindow = '';

            this._http.post<any>(`${environment.apiUrl}mycoopbuildings/findmyCoopBuilding`, { address: tempCoords, placeId: this.address.placeId })
              .pipe(
                map(response => response)
              )
              .subscribe(
                data => {
                  let buildingData = data;
                  
                  if (!buildingData) {
                    this.store.dispatch({ type: ADD_BUILDING, payload: <any>{ address: this.address } });
                    this.router.navigate(['/building', 'addbuilding'])
                      .then(() => {})
                      .catch((navError) => {});
                    return;
                  }
                  if (!this.isManagerStatus) {
                    if (!this.replaceBuildingByRes) {
                      console.log('Attempting to navigate to join building...');
                      this.store.dispatch({ type: JOIN_BUILDING, payload: { address: buildingData } });

                      this.router.navigate(['/building', 'join', buildingData.formattedAddress])
                        .then(() => {})
                        .catch((error) => {});
                    }
                  } else {
                    if (this.userPlan === 'manager' && this.isManagerStatus) {
                      this.store.dispatch({ type: JOIN_BUILDING, payload: { address: buildingData } });
                      this.router.navigate(['/building', 'join', buildingData.formattedAddress]);
                    } else if (!this.replaceBuildingByRes) {
                      this.store.dispatch({ type: JOIN_BUILDING, payload: { address: buildingData } });
                      this.router.navigate(['/building', 'join', buildingData.formattedAddress]);
                    }
                  }
                },
                (error) => {
                  this.store.dispatch({ type: ADD_BUILDING, payload: <any>{ address: this.address } });  
                  this.router.navigate(['/building', 'addbuilding'])
                    .then(() => {})
                    .catch((navError) => {});
                });
          } else {
            this.error = "This address is not available, please select any other suggestion from the list";
          }
        })
    }
  }

  buildingSearch() {
    this.submitted = false;

    if (this.addressInput == undefined || this.addressInput.trim() == '') {
      if (this.isAllowedError()) {
        this.error = 'Please enter your address';
        this.isReportToMycoop = false;
      }
    } else if (this.addressInput.length > 0 && this.place == undefined) {
      this.isReportToMycoop = true;
      this.error = null;
      this.modalWindow = "#myModal";
      this.addCustomDisClass();
      this.emitter.eventEmit$.next({ conflict_Adr: this.addressInput });
      if (this.isAllowedError()) { 
        this.isAddressBarPageOrPopup = 'addressBarPopup';
      }
    } else {
      this.isReportToMycoop = false;
      this.error = null;
      this.modalWindow = null;
      if (this.href == '/pricing' || this.href == '/about-us') {
        this.error = this.plan.getError();
      }
    }
  }

  addressNotFindReport() {
    if (this.inputAddress == undefined && this.addressInput == undefined) {
      this.error = "please enter your address";
    } else if (this.addressInput != undefined) {
      console.log(this.addressInput)
    }
  }

  inputChangeDetect() {
    this.error = '';
    this.addressInput = this.addressInput.trim();
    console.log('Address Input', this.addressInput);
    this.emitter.eventEmit$.next({ homeReset: true });
  }

  coordsRoundUp(address) {
    console.log(address, "rrrrrrrrrrrrrrrrrr")

    let coords = { ...address.coords }

    let lat = coords.lat;
    let lng = coords.lng;

    let latLength = lat.toString().split(".")[1].length;
    let lngLength = lng.toString().split(".")[1].length;

    if (latLength > 7) {
      lat = lat.toFixed(7);
      address.coords.lat = parseFloat(lat)
    }

    if (lngLength) {
      lng = lng.toFixed(7);
      address.coords.lng = parseFloat(lng);
    }
  }

  isAllowedError(): boolean {
    const currentUrl = this.href;
    return currentUrl == '/' || currentUrl == '/pricing' || currentUrl == '/about-us' || /mybuilding/.test(currentUrl);
  }

  addCustomDisClass() {
    const element = document.querySelector('#addSearchModal .customDis');
    if (element) {
      element.classList.add('inline');
    }
  }

  openModal(modalId: string) {
    const modal = document.getElementById(modalId);
    if (modal) {
      modal.style.display = 'block';
      modal.classList.add('show');
    }
  }

  closeModal(modalId: string) {
    const modal = document.getElementById(modalId);
    if (modal) {
      modal.style.display = 'none';
      modal.classList.remove('show');
    }
    if (modalId === 'addSearchModal') {
      this.error = null;
      const searchInput = document.querySelector('.serachBuildingAddress') as HTMLInputElement;
      if (searchInput) {
        searchInput.value = '';
      }
      const customDis = document.querySelector('#addSearchModal .customDis');
      if (customDis) {
        customDis.classList.remove('inline');
      }
    }
  }
}